export const PermissionSize = {
    PUT: "mgr-sizes-**-PUT",
    POST: "mgr-sizes-POST",
    DELETE: "mgr-sizes-**-DELETE",
    GET: "mgr-sizes-GET",
    GET_UUID: "mgr-sizes-**-GET"
};